module.exports = __webpack_public_path__ + "static/media/SWSCRC1-14.5b0a06be.mp3";